import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminBackgroundTaskType } from '../enums/admin-background-task-type';
import { BackgroundTaskTypeProviderService } from '../providers';

@Pipe({
  name: 'adminBackgroundTaskType',
})
export class BackgroundTaskTypePipe implements PipeTransform {
  private readonly provider = inject(BackgroundTaskTypeProviderService);

  public transform(type: AdminBackgroundTaskType): Observable<string> {
    return this.provider.labelFor(type);
  }
}
